<template>
  <div class="trip-dates">
    <div class="trip-dates__start">
      {{ startDate | fmtDate }}
    </div>

    <div
      v-if="endDate && startDate !== endDate"
      class="trip-dates__end"
    >
      {{ endDate | fmtDate }}
    </div>
  </div>
</template>

<script>
import { fmtDate } from '@/plugins/filters'

export default {
  props: {
    startDate: {
      type: String,
      default: null
    },
    endDate: {
      type: String,
      default: null
    }
  },
  computed: {
    pieces () {
      let pieces = []

      let s = this.startDate ? fmtDate(this.startDate).split(' ') : []
      let e = this.endDate ? fmtDate(this.endDate).split(' ') : []

      for (let i in s) {
        pieces.push((s[i] === e[i] || !e[i]) ? [ s[i] ] : [ s[i], e[i] ])
      }

      return pieces
    }
  }
}
</script>

<style lang="scss">
.trip-dates {
  position: relative;
  display: inline-block;

  &__end {
    margin-left: 1.5em;

    &::before {
      content: "";
      height: 150%;
      border-left: 2px solid #ffffff5c;
      position: absolute;
      transform: rotateZ(45deg);
      left: 50%;
      top: -25%;
    }
  }
}
</style>
